import { memo } from 'react'
import { DevActionsGroup, TinyButton } from './styles'
import { zkexConnection } from '../../ws/zkex'
import { store } from 'store'
import { DevToolsPopup } from './DevToolsPopup'

export const WsConnection = memo(() => {
  return (
    <DevToolsPopup
      popup={
        <DevActionsGroup>
          <TinyButton
            onClick={() => {
              console.log(zkexConnection)
            }}
          >
            Ws Status
          </TinyButton>
          <TinyButton
            onClick={() => {
              zkexConnection.disconnect()
            }}
          >
            Disconnect With 1000
          </TinyButton>
          <TinyButton
            onClick={() => {
              zkexConnection.disconnect(3000)
            }}
          >
            Disconnect With 3000
          </TinyButton>
          <TinyButton
            onClick={() => {
              zkexConnection.connect(store.getState().account.token)
              zkexConnection.connect(store.getState().account.token)
              zkexConnection.connect(store.getState().account.token)
            }}
          >
            Concurrent Connect
          </TinyButton>
        </DevActionsGroup>
      }
    >
      <TinyButton>Ws Connection</TinyButton>
    </DevToolsPopup>
  )
})
